(function () {

  'use strict';

  function pxInviteUsers(
    $filter, $location, $log, $rootScope, $timeout, $translate, focus, toastr, UserListService, RegexModel,
    ApplicationType, CpuArchitecture, FileType, OperatingSystem, PrintixVersion, SoftwareService, UpdateStrategy
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        workstationCount: '=workstationCount'
      },
      templateUrl: 'app/components/deployAssistant/inviteUsers/inviteUsers.template.html',
      link: function (scope) {

        scope.ApplicationType = ApplicationType;
        scope.CpuArchitecture = CpuArchitecture;
        scope.FileType = FileType;
        scope.OperatingSystem = OperatingSystem;

        scope.clientNameValue = $rootScope.clientNameValue;
        scope.showMsiArgumentsButton = false;
        scope.error = null;
        scope.invite = { type: 'INVITE_MANY_USERS' };
        scope.newUserDetails = {
          email: null,
          grantAdminAccess: false
        };
        scope.userEmailAddressFocusKey = 'userEmailAddressFocusKey';
        scope.currentOEM = $rootScope.currentOEM;
        scope.currentAppName = $rootScope.currentAppName;
        scope.emailValid = false;

        scope.checkEmail = function () {
          const regex = new RegexModel();
          scope.emailValid = regex.emailRegex().test(scope.newUserDetails.email);
          return scope.emailValid;
        };

        scope.addUser = function () {
          const dataToSend = {
            email: scope.newUserDetails.email,
            lang: $translate.use(),
            grantAdminAccess: scope.newUserDetails.grantAdminAccess
          };
          UserListService.createUser(dataToSend)
            .then(function () {
              scope.newUserDetails = {
                email: null,
                grantAdminAccess: false
              };
              scope.emailValid = false;
              toastr.success($filter('translate')('EmailSent'));
            })
            .catch(function (error) {
              scope.error = error;
            });
        };

        scope.clearError = function () {
          scope.error = null;
        };

        function isolateTenantId() {
          let tenantId = scope.tenant.info._links.self.href.split('/');
          tenantId = tenantId[tenantId.length - 1];
          const wrapper1 = `WRAPPED_ARGUMENTS=/id:${tenantId}${dataCenter()}`;
          const wrapper2 = `WRAPPED_ARGUMENTS=/id:${tenantId}${dataCenter()}:oms`;
          scope.msiArgs = { tenantId, wrapper1, wrapper2 };
        }

        function dataCenter() {
          const url = $location.absUrl();
          if (!url.includes('/admin')) {
            return '';
          }
          const domainUrl = url.split('/admin');
          const domain = domainUrl[0].split('.');
          const dataCenter = domain[domain.length - 3];
          switch (dataCenter) {
            case 'us':
              return ':dc:us';
            default:
              return '';
          }
        }

        scope.openContextMenu = function (event, context, menuOption) {
          $timeout(function () {
            scope.selectedContextMenuItem = menuOption;
            scope.contextPosition = { left: event.clientX, top: event.clientY };
            scope.context = context;
            scope.resource = scope.currentTenant;
          });
        };

        scope.closeAllMenues = function () {
          scope.selectedContextMenuItem = null;
          scope.contextPosition = null;
          scope.context = null;
        };

        scope.focusEmailInput = function (event) {
          focus(scope.userEmailAddressFocusKey);
        };

        scope.openDownloadDesktopApplicationDialog = function (applicationType, operatingSystem, cpuArchitecture, fileType) {
          const application = scope.softwareVersions.applications
            .find(application => application.appType === applicationType && application.os === operatingSystem);

          if (!application) {
            $log.error(`No application found for type ${applicationType} and OS ${operatingSystem}`);
            return;
          }

          const availableVersions = angular.copy(application.availableVersions || []);
          let specificVersion = application.specificVersion;
          if (specificVersion) {
            const foundSpecificVersion = availableVersions.find(availableVersion => availableVersion.version === specificVersion.version);
            if (!foundSpecificVersion) {
              specificVersion = angular.copy(specificVersion);
              specificVersion.obsolete = true;
              availableVersions.push(specificVersion);
            }
          }

          const downloadableVersions = availableVersions
            .filter(availableVersion => availableVersion.files.some(file => (!cpuArchitecture || file.cpuArch === cpuArchitecture) && file.type === fileType))
            .sort((first, second) => new PrintixVersion(second.version).compareTo(new PrintixVersion(first.version)))
            .map(availableVersion => {
              return {
                version: availableVersion.version,
                obsolete: availableVersion.obsolete,
                downloadUrl: SoftwareService.buildDesktopApplicationDownloadUrl(applicationType, operatingSystem, cpuArchitecture, fileType, availableVersion.version)
              };
            });

          let currentVersion;
          switch (scope.softwareVersions.updateStrategy) {
            case UpdateStrategy.ADVANCE:
              currentVersion = application.advanceVersion;
              break;
            case UpdateStrategy.GENERAL:
              currentVersion = application.generalVersion;
              break;
            case UpdateStrategy.SPECIFIC:
              currentVersion = application.specificVersion.version;
              break;
          }

          scope.applicationVersionData = {
            applicationType,
            operatingSystem,
            cpuArchitecture,
            fileType,
            availableVersions: downloadableVersions,
            currentVersion,
            advanceVersion: application.advanceVersion,
            generalVersion: application.generalVersion,
            customVersion: application.customVersion
          };

          scope.isDownloadDesktopApplicationDialogVisible = true;
        };

        scope.closeDownloadDesktopApplicationDialog = function () {
          scope.isDownloadDesktopApplicationDialogVisible = false;
        };

        (function () {
          isolateTenantId();
          loadSoftwareVersions();
        })();

        function loadSoftwareVersions() {
          SoftwareService.getVersionsOfDesktopApplications()
            .then(function (softwareVersions) {
              scope.softwareVersions = softwareVersions;
            })
            .catch(function () {
            });
        }

      }
    };
  }

  pxInviteUsers.$inject = [
    '$filter', '$location', '$log', '$rootScope', '$timeout', '$translate', 'focus', 'toastr', 'UserListService', 'RegexModel',
    'ApplicationType', 'CpuArchitecture', 'FileType', 'OperatingSystem', 'PrintixVersion', 'SoftwareService', 'UpdateStrategy'
  ];

  angular
    .module('printix-admin')
    .directive('pxInviteUsers', pxInviteUsers);

})();
